/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Branches_Dialog_Edit_TitleInputs */

const en_branches_dialog_edit_title = /** @type {(inputs: Branches_Dialog_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit branch`)
};

const pt_br2_branches_dialog_edit_title = /** @type {(inputs: Branches_Dialog_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar filial`)
};

/**
* | output |
* | --- |
* | "Edit branch" |
*
* @param {Branches_Dialog_Edit_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const branches_dialog_edit_title = /** @type {((inputs?: Branches_Dialog_Edit_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Branches_Dialog_Edit_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_branches_dialog_edit_title(inputs)
	return pt_br2_branches_dialog_edit_title(inputs)
});